import type { ToastOptions } from 'react-toastify';
import type { ToastAction } from './ToastMessage';

export const toastOptionsFor = (action?: ToastAction): ToastOptions =>
    action ? { autoClose: false, closeOnClick: false, draggable: false } : {};
